import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {
  LovValueSummaryFindAllService
} from '../../../../../../common/lov/lov-value/impl/service/lovValueSummaryFindAll.service';
import {BehaviorSubject, Subscription} from 'rxjs';
import {
  MedicalRecordVisitReasonLabelsCachedFindAllService
} from '../../service/medicalRecordVisitReasonLabelsCachedFindAll.service';
import {SelectElement} from '../../../../../../../components/common/select/select.model';

@Component({
  selector: 'app-medical-record-visit-reason-labels-select-filter',
  templateUrl: './medical-record-visit-reason-labels-select-filter.component.html',
  providers: [MedicalRecordVisitReasonLabelsCachedFindAllService, LovValueSummaryFindAllService]
})
export class MedicalRecordVisitReasonLabelsSelectFilterComponent implements OnInit, OnDestroy {

  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;

  subscription: Subscription;
  lovValueElements: SelectElement[] = [];

  constructor(public lovValueSummaryFindAllService: MedicalRecordVisitReasonLabelsCachedFindAllService) {
  }

  ngOnInit(): void {
    this.subscription = this.lovValueSummaryFindAllService.entities$.subscribe(values => {
      this.lovValueElements = values.map(value => {
        const label = value.lovListName === 'MEDICAL_RECORD_PAIN_WHERE' ? '<strong>Douleur</strong> : ' + value.label : value.label;
        return new SelectElement(value.value, label);
      }).sort((a, b) => a.label.localeCompare(b.label));
    });
    this.lovValueSummaryFindAllService.findAll();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
